import React from 'react';
import numeral from 'numeral';
import Helmet from 'react-helmet';
import { Link } from 'react-router-dom';
import { MdDone } from 'react-icons/md';
import { FiLoader,FiAlertTriangle } from 'react-icons/fi';

export default ({ state }) => {

  const { payment, loading } = state;

  if (!!loading) return(<LoadingScreen/>);

  if (!loading && !payment.ipay_id) return(<ErrorMessage/>);

  if (!loading && !!payment.ipay_id) return(<Content state={state}/>);

}

const Content = ({ state }) => {

  const { order, payment } = state;

  const format = (a) => numeral(a).format('0,0.00');

  const {
    city='',
    cart=[],
    amount=0,
    location='',
    address_2='',
    first_name='',
    email_address='',
    delivery_method={}
  } = order;

  const { caption='', charge=0 } = delivery_method;

  return (
    <div className='Checkout-Complete-Wrapper'>

      <Helmet title={`Thank you ${first_name}! | Adenzo Comfies`}/>

      <div className="customer-information">

        <div className="order-details">

          <div className="caption">{`#${payment.ipay_id}`}</div>

          <div className="title">
            <div className="icon-wrapper">
              <MdDone className='icon'/>
            </div>
            <div className="label">{`Thank you ${first_name}!`}</div>
          </div>

          <div className="card-outline">
            <div className="card-title">Your order is confirmed</div>
            <div className="card-content">You’ll receive an email when your order is ready.</div>
          </div>

          <div className="card-outline">

            <div className="card-title">Customer Information</div>

            <div className="card-section">
              <div className="card-section-title">Contact information</div>
              <div className="card-content">{email_address}</div>
            </div>

            <div className="card-section">
              <div className="card-section-title">Payment method</div>
              <div className="card-content">{`MPESA - Ksh ${amount}`}</div>
            </div>

            <div className="card-section">
              <div className="card-section-title">Shipping address</div>
              <div className="card-content">{address_2}</div>
              <div className="card-content">{`${location}, ${city}`}</div>
            </div>

          </div>

        </div>

      </div>

      <div className="customer-order-summary">

        <div className="product-list">
          { cart.map(({title, image, pricing, quantity},i) =>
              <div key={i} className='product'>

                <div className="image" style={{backgroundImage: `url(${image})`}}/>

                <div className="description">
                  <div className="name">{title}</div>
                  <div className="pricing">Ksh {format(pricing.price)} x {quantity} PCS</div>
                </div>

                <div className="total">
                  {format(quantity * pricing.price)}
                </div>

              </div>
            )
          }
        </div>

        <div className="divider"/>

        <div className="summary-row">
          <div className="label">Subtotal</div>
          <div className="value">{format(amount - charge)}</div>
        </div>

        <div className="summary-row">
          <div className="label">{`Delivery (${caption})`}</div>
          <div className="value">{format(charge)}</div>
        </div>

        <div className="summary-row bold">
          <div className="label bold">Total</div>
          <div className="value bold">Ksh {format(amount)}</div>
        </div>

      </div>

    </div>
  )
}

const LoadingScreen = () => {
  return (
    <div className='loading-animation noselect'>
      <FiLoader className='icon loader'/>
      <div className="caption">Verifying Payment...</div>
    </div>
  )
}

const ErrorMessage = () => {
  return (
    <div className='payment-error noselect'>
      <FiAlertTriangle className='icon'/>
      <div className="title">Payment Failed!</div>
      <div className="caption">
        There seems to be a problem with your payment. Kindly contact our customer care with your Transaction ID (M-Pesa/Bank) for further assistance.
      </div>
      <Link to='/home' className="button">
        Go to Homepage
      </Link>
    </div>
  )
}
